import NavBar from "@/components/navigation/NavBar";
import GoogleReviewSummary from "@/components/Landingpage/GoogleStars";
import { React, useState, useEffect } from "react";
import Footer from "@/components/navigation/Footer";
import { sanityApi } from "@/features/sanity";
import { Rating } from "@mui/material";
import CtaContact from "@/components/calltoaction/CtaContact";
import Stats from "@/components/proofs/Stats";

export default function Referenzen() {
  const [referenzen, setReferenzen] = useState([]);

  useEffect(() => {
    async function loadReferenzen() {
      const data = await sanityApi.fetchReferenzen();
      setReferenzen(data);
    }
    loadReferenzen();
    console.log(referenzen);
  }, []);
  function isEven(n) {
    return n % 2 == 0;
  }
  return (
    <div className="bg-gray-50">
      <NavBar className="bg-white/100" />

      <div className="pt-20 max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className=" pt-10 flex flex-col-reverse md:grid md:grid-cols-2 gap-4 md:gap-8 xl:gap-20 md:items-center">
          <div>
            <p className="block text-lg font-medium text-prime-800 sm:text-xl lg:text-2xl lg:leading-tight">
              Menschen und Immobilien
            </p>
            <h1 className="block text-3xl font-bold text-dark-100 sm:text-4xl lg:text-6xl lg:leading-tight">
              Unsere Referenzen
            </h1>
            <p className="mt-3 text-lg text-gray-600">
              Jede Immobilie erzählt eine Geschichte und jeder Verkauf ist ein
              Meilenstein im Leben unserer Kunden. Hier teilen sie ihre
              Erfahrungen mit uns – echt, wertschätzend und aus erster Hand. Und
              wir teilen unsere Begeisterung, sie auf diesem Weg begleiten zu
              dürfen.
            </p>

            <div className="mt-6 lg:mt-10 grid grid-cols-2 gap-x-5"></div>
          </div>
          <div className="relative ms-4">
            <img
              className="w-full rounded-md"
              src="/Fotos/referenzen-hero-jakobs.webp"
              alt="Leon Jakobs vor Referenzen der erfolgreich verkauften Immobilien"
            />
            <div className="absolute inset-0 -z-[1] bg-gradient-to-tr from-gray-200 via-white/0 to-white/0 size-full rounded-md mt-4 -mb-4 me-4 -ms-4 lg:mt-6 lg:-mb-6 lg:me-6 lg:-ms-6"></div>
          </div>
        </div>
      </div>
      <div className="md:pt-10">
        <Stats />
      </div>
      <section className="bg-gray-100 py-10">
        <div>
          <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto py-10">
            <h2 className="md:text-3xl text-2xl font-semibold font-serif text-dark-100 max-w-[70vw]">
              Jede Immobilie ist einzigartig – Einblick in die Vermarktung
            </h2>
            <p className="mt-3 text-lg text-gray-600 md:max-w-[50vw]">
              Unsere Kunden sind begeistert von unserer Arbeit. Überzeugen Sie
              sich selbst und lesen Sie, was sie über uns sagen.
            </p>
            <div className="flex  flex-col gap-28 py-20">
              {referenzen.map((referenz, index) => (
                <div
                  className={`flex justify-start flex-col ${
                    isEven(index)
                      ? "md:flex-row flex-col"
                      : "flex col  md:flex-row-reverse"
                  } gap-10`}
                >
                  <div className="md:w-1/2">
                    <img
                      className="w-full object-cover"
                      src={referenz.image}
                      alt=""
                    />
                  </div>
                  <div
                    className={`md:w-1/2 ${
                      isEven(index) ? "md:pl-10" : "md:pr-10"
                    }`}
                  >
                    <h3 className="text-xl md:text-2xl font-serif pb-5 font-semibold text-prime-950">
                      {referenz.title}
                    </h3>
                    <p>{referenz.description} </p>
                    <div className="pt-10 flex items-center justify-start gap-4">
                      <img
                        src={referenz.avatar}
                        className="size-14 object cover rounded-full"
                        alt=""
                      />
                      <div>
                        <h4 className="font-semibold text-lg text-dark-100">
                          {referenz.name}
                        </h4>
                        <p className="text-gray-500">
                          {new Date(referenz.date).toLocaleDateString("de-DE")}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="pt-5">
                      <Rating
                        size="large"
                        max={5}
                        value={referenz.stars}
                        precision={1}
                        readOnly
                      />
                      <i>
                        <p>{referenz.quote}</p>
                      </i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className="py-20 bg-gray-50">
        <CtaContact />
      </div>
      <Footer />
    </div>
  );
}
